var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSygeplejeklinik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sygeplejeklinik",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;}\r\n\t.st1{fill:#474647;}\r\n\t.st2{fill:#777775;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.6,28.8c-3.3-3.4-7.8-5.2-12.5-5.2c-4.3,0-8.3,1.5-11.5,4.2c-3.2-2.7-7.2-4.2-11.5-4.2 c-4.7,0-9.2,1.8-12.5,5.2c-5.1,5.1-7.2,11.3-6.1,17.8c2,11.2,13.3,22.9,29.5,30.6c0.2,0.1,0.4,0.1,0.6,0.1s0.4,0,0.6-0.1 c16.2-7.6,27.6-19.3,29.5-30.6C79.8,40.1,77.7,33.9,72.6,28.8z M58.6,53.4c0,0.8-0.6,1.4-1.4,1.4h-4.3v4.3c0,0.8-0.6,1.4-1.4,1.4 h-5.8c-0.8,0-1.4-0.6-1.4-1.4v-4.3h-4.3c-0.8,0-1.4-0.6-1.4-1.4v-5.8c0-0.8,0.6-1.4,1.4-1.4h4.3v-4.3c0-0.8,0.6-1.4,1.4-1.4h5.8 c0.8,0,1.4,0.6,1.4,1.4v4.3h4.3c0.8,0,1.4,0.6,1.4,1.4V53.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.5,27.9c-3.3-3.4-7.8-5.2-12.5-5.2c-4.3,0-8.3,1.5-11.5,4.2c-3.2-2.7-7.2-4.2-11.5-4.2 c-4.7,0-9.2,1.8-12.5,5.2c-5.1,5.1-7.2,11.3-6.1,17.8c2,11.2,13.3,22.9,29.5,30.6c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.6-0.1 c16.2-7.6,27.6-19.3,29.5-30.6C80.7,39.2,78.6,33,73.5,27.9z M59.6,52.4c0,0.8-0.6,1.4-1.4,1.4h-4.3v4.3c0,0.8-0.6,1.4-1.4,1.4 h-5.8c-0.8,0-1.4-0.6-1.4-1.4v-4.3h-4.3c-0.8,0-1.4-0.6-1.4-1.4v-5.8c0-0.8,0.6-1.4,1.4-1.4h4.3v-4.3c0-0.8,0.6-1.4,1.4-1.4h5.8 c0.8,0,1.4,0.6,1.4,1.4v4.3h4.3c0.8,0,1.4,0.6,1.4,1.4V52.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSygeplejeklinik);
export default __webpack_public_path__ + "static/media/Sygeplejeklinik.cc2f5531d794ec7975f77ac9f752ba0c.svg";
export { ForwardRef as ReactComponent };